//const URLEndPointBE = "http://localhost:3001"
// const URLEndPointBE = "https://appt.iprpraha.cz/nex/kdp-ipr"
//const URLEndPointBE = "/api/listing/doplnky"
const URLEndPointBE = "https://katalogprvku.iprpraha.cz/backend"
export default URLEndPointBE
